<template>
  <LocalizationAdmin />
</template>

<script>
import LocalizationAdmin from "@shared/modules/localization/index.vue"

export default {
  components: {
    LocalizationAdmin,
  }
}
</script>

<style lang="scss" scoped></style>